import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WelcomeComponent } from './components/welcome.component';
import { TranslateModule } from '@ngx-translate/core';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { WelcomeService } from './welcome.service';

@NgModule({
  declarations: [WelcomeComponent],
  providers:[WelcomeService],
  imports: [
    CommonModule,
    TranslateModule,
    NgbTooltipModule
  ],
  exports:[
    WelcomeComponent
  ]
})
export class WelcomeModule { }
